import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Pillars } from "@/components/site/Pillars";
import { Services } from "@/components/site/Services";
import { Products } from "@/components/site/Products";
import { Teaching } from "@/components/site/Teaching";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { SideRail } from "@/components/site/SideRail";
import { Toaster } from "@/components/ui/sonner";

const Home = () => (
  <main data-testid="home-page" className="relative bg-ink-800 text-white overflow-hidden">
    <Navbar />
    <SideRail />
    <Hero />
    <About />
    <Pillars />
    <Services />
    <Products />
    <Teaching />
    <Contact />
    <Footer />
    <Toaster />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
